module.exports = __webpack_public_path__ + "img/jxs.6c031b6e.jpg";